module.exports = __webpack_public_path__ + "img/dot-shape-1.db52291.svg";